import { render, staticRenderFns } from "./ot-change-password-dialog.vue?vue&type=template&id=52aaa9f4&scoped=true&"
import script from "./ot-change-password-dialog.vue?vue&type=script&lang=ts&"
export * from "./ot-change-password-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./ot-change-password-dialog.vue?vue&type=style&index=0&id=52aaa9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aaa9f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
